<template>
	<div class="menu">
		<el-menu
			:default-active="activeMenu"
			:unique-opened="true"
			:router="true"
			ref="elMenu"
			@select="changeMenu"
			background-color="transparent"
			text-color="#b0c4de"
			active-text-color="#409eff"
			class="custom-menu"
		>
			<MenuItem :item="authMenu" />
		</el-menu>
	</div>
</template>

<script>
	import MenuItem from "./MenuItem";
	import routes from "@/router/routes.js";
	import { mapGetters } from "vuex";

	export default {
		name: "Menu",
		components: { MenuItem },
		computed: {
			...mapGetters(["permissions", "authMap"]),
			activeMenu() {
				return this.$route.meta.key;
			},
		},

		mounted() {
			// 针对用户档案页面点击查看操作后弹出的新页面的菜单处理
			if (
				["detailAbnormal", "detailExamination"].includes(this.$route.name)
			) {
				this.$root.showName = false;
				this.dealMenu(
					[
						{
							path: "/user/detail-abnormal",
							name: "",
							meta: {
								title: "档案信息",
								icon: "el-icon-notebook-2",
								authCode: "sa_user_abnormal_page",
								key: "user_detail_abnormal",
							},
							children: [
								{
									path:
										"/user/detail-abnormal?userId=" +
										this.$route.query.userId,
									name: "detailAbnormal",
									meta: {
										title: "异常指标解读",
										authCode: "sa_user_abnormal_page",
										key: "detailAbnormal",
									},
								},
							],
						},
						{
							path: "/user/detail-examination",
							name: "",
							meta: {
								title: "服务记录",
								icon: "el-icon-notebook-2",
								authCode: "sa_user_order_page",
								key: "user_detail_examination",
							},
							children: [
								{
									path:
										"/user/detail-examination?userId=" +
										this.$route.query.userId,
									name: "detailExamination",
									meta: {
										title: "体检服务记录",
										authCode: "sa_user_order_page",
										key: "detailExamination",
									},
								},
							],
						},
					],
					this.authMenu
				);
			} else {
				this.dealMenu(routes, this.authMenu);
			}
		},
		data() {
	return {
		authMenu: [],
	};
},
		methods: {
			changeMenu(href) {
		sessionStorage.removeItem("searchCache");
		if (href === this.$route.fullPath) {
			this.$root.showPage = false;
		}
	},
			isAuth(item) {
				let canUse = false;
				let authCode = item.meta && item.meta.authCode;
				if (typeof authCode === "undefined") {
					canUse = true;
				} else if (typeof authCode === "boolean" && authCode) {
					canUse = true;
				} else if (typeof authCode === "string" && authCode) {
					canUse = this.authMap[authCode];
				}
				return canUse;
			},
			//递归处理菜单所属权限
			dealMenu(obj, arrT) {
				let newArr = [];
				obj.forEach((item) => {
					//判断是单菜单路由还是多菜单路由
					if (item.children) {
						let arr = item.children.filter((content) => {
							return content.meta.authCode;
						});
						if (arr.length == 0) {
							item.noAuthCode = true;
						}
					}
					if (item.children && item.children.length > 0) {
						//如果有多个子菜单时
						if (this.isAuth(item)) {
							let obj = { ...item, children: [] };
							console.log('obj', obj);
							newArr.push(obj);
							//对其children再次执行dealMenu()函数
							this.dealMenu(item.children, obj.children);
						}
					} else {
						// 如果只有一个子菜单
						if (this.isAuth(item)) {
							console.log('item', item);
							newArr.push({ ...item });
						}
					}
				});
				newArr.forEach(_item => {
					if (_item?.meta?.hideMenu !== true) {
						arrT.push(_item);
					}
				})
				sessionStorage.setItem("authMenu", JSON.stringify(this.authMenu));
			},
		},
	};
	// export default Mole (){
	// setup(){
	// 	onMounted(async () => {
	// 	// const model  = await getModel(option.value); //model是其他页面需要获取的变量
	// 	// model.addEventListener("click", () => {
	// 	// 	console.log("hello world")
	// 	// 	Mole=model //给model添加的方法里把model存储到Mole里
	// 	// });
	// 	});
	// }
	// };
	//
	// export let Mole = "null"
</script>

<style lang="scss" scoped>
@import "@/assets/css/color.scss";

.menu {
	padding: 0;
	height: calc(100vh - 120px);
	overflow-y: auto;
	overflow-x: hidden;
}

// 滚动条样式
.menu::-webkit-scrollbar {
	width: 4px;
}

.menu::-webkit-scrollbar-track {
	background: transparent;
}

.menu::-webkit-scrollbar-thumb {
	background: rgba(255, 255, 255, 0.15);
	border-radius: 2px;
}

.menu::-webkit-scrollbar-thumb:hover {
	background: rgba(255, 255, 255, 0.25);
}

// 深度选择器修改 Element UI 菜单样式
::v-deep .custom-menu {
	border-right: none;
	
	// 重置 Element UI 默认样式
	.el-menu-item, .el-submenu__title {
		background-color: transparent !important;
	}
	
	// 一级菜单样式
	> .el-menu-item,
	> .el-submenu > .el-submenu__title {
		height: 50px;
		line-height: 50px;
		margin: 0;
		border-radius: 0;
		background: transparent !important;
		border: none;
		border-left: 3px solid transparent;
		transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
		padding-left: 20px !important;
		font-size: 14px;
		
		i {
			margin-right: 10px;
			font-size: 16px;
			width: 20px;
			text-align: center;
		}
	}

	> .el-menu-item:hover,
	> .el-submenu > .el-submenu__title:hover {
		background: rgba(255, 255, 255, 0.12) !important;
		color: #fff !important;
	}

	> .el-menu-item.is-active {
		background: rgba(64, 158, 255, 0.12) !important;
		border-left-color: #409eff;
		color: #409eff !important;
	}

	// 子菜单展开样式
	> .el-submenu.is-opened > .el-submenu__title {
		background: rgba(255, 255, 255, 0.12) !important;
		color: #fff !important;
	}

	.el-submenu {
		// 二级菜单样式
		.el-menu {
			background: transparent !important;
			padding: 0 !important;
		}

		.el-menu-item {
			height: 44px;
			line-height: 44px;
			margin: 0;
			border-radius: 0;
			background: transparent !important;
			border: none;
			border-left: 3px solid transparent;
			padding-left: 50px !important;
			font-size: 13px;
			color: #8fa4c0 !important;
			transition: background-color 0.2s ease, color 0.2s ease, border-color 0.2s ease;
			
			i {
				margin-right: 8px;
				font-size: 14px;
				width: 18px;
				text-align: center;
			}
		}

		.el-menu-item:hover {
			background: rgba(255, 255, 255, 0.12) !important;
			color: #fff !important;
		}

		.el-menu-item.is-active {
			background: rgba(64, 158, 255, 0.12) !important;
			border-left-color: #409eff;
			color: #409eff !important;
		}

		// 三级菜单样式
		.el-submenu {
			.el-menu-item {
				padding-left: 70px !important;
				font-size: 12px;
			}
		}

		.el-submenu__title {
			i {
				transition: transform 0.3s ease;
			}
		}

		&.is-opened {
			> .el-submenu__title {
				background: rgba(255, 255, 255, 0.12) !important;
				.el-submenu__icon-arrow {
					transform: rotate(180deg);
				}
			}
		}
		
		// 优化子菜单展开动画，减少跳动
		.el-menu {
			transition: max-height 0.3s ease, opacity 0.3s ease;
			max-height: 0;
			overflow: hidden;
		}
		
		&.is-opened .el-menu {
			max-height: 500px; /* 足够容纳所有子菜单项 */
		}
	}

	.el-submenu__icon-arrow {
		transition: transform 0.3s ease;
		font-size: 12px;
		margin-top: -6px;
	}
}
</style>
